import { Row, Col, Card, Typography, Spin, Tooltip, Progress } from "antd";
import {
  FaUsers,
  FaUserCheck,
  FaUserClock,
  FaUserTimes,
  FaPhone,
  FaChartLine,
  FaCalendarDay,
  FaUserMinus,
  FaInfoCircle,
  FaMale,
  FaFemale
} from "react-icons/fa";
const { Title, Text } = Typography;

export default function TotalesCards({
  totales,
  metricasLlamadas,
  tasaExito,
  promedioDia,
  noVerificadosTotales,
  loading = false
}) {
  // Mostrar spinner mientras carga
  if (loading || !totales) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
        <Spin size="large" tip="Cargando métricas..." />
      </div>
    );
  }
  const totalParticipantes = totales.totalParticipantes || 0;
  const llamadasRealizadas = metricasLlamadas?.llamadasRealizadas || 0;
  const personasLlamadas = metricasLlamadas?.personasLlamadas || 0;
  const porcentajeCobertura = totalParticipantes > 0 ? (personasLlamadas / totalParticipantes) * 100 : 0;
  const getPercentage = (value) => { return totalParticipantes > 0 ? ((value / totalParticipantes) * 100).toFixed(1) : 0; };
  const getGenderInfo = (hombres, mujeres) => {
    const total = (hombres || 0) + (mujeres || 0);
    const porcentajeHombres = total > 0 ? ((hombres / total) * 100).toFixed(0) : 0;
    const porcentajeMujeres = total > 0 ? ((mujeres / total) * 100).toFixed(0) : 0;


    return (
      <div style={{ fontSize: 11, color: '#666', marginTop: 4 }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <FaMale size={10} color="#3B82F6" /> {hombres || 0} ({porcentajeHombres}%) <FaFemale size={10} color="#EC4899" /> {mujeres || 0} ({porcentajeMujeres}%)
        </span>
      </div>
    );
  };

  const formatNumber = (num) => {
    return Number(num || 0).toLocaleString("es-CO");
  };

  const cards = [
    {
      label: "Total participantes",
      value: formatNumber(totales.totalParticipantes),
      icon: <FaUsers size={28} color="#2979FF" />,
      color: "#2979FF",
      tooltip: "Número total de participantes registrados en el sistema",
      showPercentage: false,
      extraInfo: getGenderInfo(totales.hombresTotales, totales.mujeresTotales),
      showGender: true
    },
    {
      label: "Verificados",
      value: formatNumber(totales.verificados?.total),
      icon: <FaUserCheck size={28} color="#20AC00" />,
      color: "#20AC00",
      tooltip: `Participantes verificados exitosamente - ${getPercentage(totales.verificados?.total || 0)}% del total`,
      percentage: getPercentage(totales.verificados?.total || 0),
      showPercentage: true,
      extraInfo: getGenderInfo(totales.verificados?.hombres, totales.verificados?.mujeres)
    },
    {
      label: "En proceso",
      value: formatNumber(totales.enProceso?.total || 0),
      icon: <FaUserClock size={28} color="#419DF8" />,
      color: "#419DF8",
      tooltip: `Participantes en proceso de validación - ${getPercentage(totales.enProceso?.total || 0)}% del total`,
      percentage: getPercentage(totales.enProceso?.total || 0),
      showPercentage: true,
      extraInfo: getGenderInfo(totales.enProceso?.hombres, totales.enProceso?.mujeres)
    },
    {
      label: "No Continúa",
      value: formatNumber(totales.noContinua?.total || 0),
      icon: <FaUserTimes size={28} color="#D62828" />,
      color: "#D62828",
      tooltip: `Participantes que no pudieron ser verificados - ${getPercentage(totales.noContinua?.total || 0)}% del total`,
      percentage: getPercentage(totales.noContinua?.total || 0),
      showPercentage: true,
      extraInfo: getGenderInfo(totales.noContinua?.hombres, totales.noContinua?.mujeres)
    },
    {
      label: "No Verificado",
      value: formatNumber(totales.noVerificados?.total || 0),
      icon: <FaUserMinus size={28} color="#B4B4B4" />,
      color: "#B4B4B4",
      tooltip: `Participantes sin proceso de validación - ${getPercentage(totales.noVerificados?.total || 0)}% del total`,
      percentage: getPercentage(totales.noVerificados?.total || 0),
      showPercentage: true,
      extraInfo: getGenderInfo(totales.noVerificados?.hombres, totales.noVerificados?.mujeres)
    },
    {
      label: "Llamadas Realizadas",
      value: formatNumber(llamadasRealizadas),
      icon: <FaPhone size={28} color="#7B1FA2" />,
      color: "#7B1FA2",
      tooltip: `Cobertura real: ${porcentajeCobertura.toFixed(2)}% (${formatNumber(personasLlamadas)} de ${formatNumber(totalParticipantes)} participantes han sido contactados al menos una vez)`,
      percentage: Number(porcentajeCobertura.toFixed(2)),
      showPercentage: true,
    },
    {
      label: "Tasa de Éxito",
      value: tasaExito?.tasaExito ? `${Math.round(tasaExito.tasaExito)}%` : "0%",
      icon: <FaChartLine size={28} color="#388E3C" />,
      color: "#388E3C",
      tooltip: `Llamadas exitosas: ${formatNumber(tasaExito?.llamadasExitosas || 0)}  de ${formatNumber(tasaExito?.totalLlamadas || 0)}  (${(tasaExito?.tasaExito || 0).toFixed(2)}%)`, percentage: Math.round(tasaExito?.tasaExito || 0),
      showPercentage: true,
    },
    {
      label: "Promedio Llamadas/Día",
      value: promedioDia?.promedioLlamadasDia ? formatNumber(Math.round(promedioDia.promedioLlamadasDia)) : 0,
      icon: <FaCalendarDay size={28} color="#1976D2" />,
      color: "#1976D2",
      tooltip: `Promedio: ${formatNumber(promedioDia?.totalLlamadas || 0)} llamadas en ${formatNumber(promedioDia?.diasConLlamadas || 0)} días`,
      percentage: Math.min(100, Math.round((promedioDia?.promedioLlamadasDia || 0) / 10 * 100)),
      showPercentage: true,
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      {cards.map((card, index) => (
        <Col xs={24} sm={12} lg={6} key={index}>
          <Tooltip title={card.tooltip} placement="top">
            <Card
              hoverable
              style={{
                borderRadius: 14,
                height: "100%",
                boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                border: `1px solid ${card.color}20`,
                transition: "all 0.3s ease",
              }}
            >
              <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
                <div
                  style={{
                    background: `${card.color}15`,
                    padding: 10,
                    borderRadius: 10,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  {card.icon}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <Title
                    level={4}
                    style={{
                      margin: 0,
                      color: card.color,
                      fontSize: "24px",
                      lineHeight: "1.2",
                      marginBottom: 4
                    }}
                  >
                    {card.value}
                  </Title>
                  <Text
                    style={{
                      fontSize: 13,
                      color: "#666",
                      fontWeight: 500,
                      display: "block",
                      marginBottom: 4
                    }}
                  >
                    {card.label}
                  </Text>
                  {/* Información de género y porcentaje */}
                  {(card.showPercentage || card.extraInfo) && (
                    <div style={{ marginTop: 8 }}>
                      {/* Barra de progreso para visualización */}
                      {card.showPercentage && index >= 5 && ( // Solo para las últimas 3 tarjetas
                        <Progress
                          percent={card.percentage}
                          size="small"
                          strokeColor={card.color}
                          showInfo={false}
                          style={{ marginBottom: 4 }}
                        />
                      )}
                      <Text
                        style={{
                          fontSize: 11,
                          color: "#999",
                          display: "block",
                          lineHeight: "1.3"
                        }}
                      >
                        {card.showPercentage && `${card.percentage}%`}
                        {card.extraInfo && (
                          <>
                            {card.showPercentage && <br />}
                            {card.extraInfo}
                          </>
                        )}
                      </Text>
                    </div>
                  )}
                </div>
                {/* Icono de información para tooltip */}
                <div style={{ flexShrink: 0, opacity: 0.6 }}>
                  <FaInfoCircle size={12} color="#999" />
                </div>
              </div>
            </Card>
          </Tooltip>
        </Col>
      ))}
    </Row>
  );
}